<ng-container *ngIf="hasFilters$ | async">
  <app-mobile-filter-bar-cont
    [isSticky]="isSticky">
    <ng-container allBtn="allBtn">
      <ng-content select="[allFiltersTag]"></ng-content>
    </ng-container>
    <ng-container selectedSlide="selectedSlide">
      <app-selected-hotel-filters
        [isMobile]="true"
        [inFilterBar]="true"
        [filters]="filters$ | async"
        [hasRappiCard]="hasRappiCard$ | async"
        [isPrime]="isPrime$ | async"
        [source]="searchSource"
        (sharedShouldShowFilters)="sharedShouldShowFiltersByHotel($event)"
        (sharedSelectedHotelFilters)="sharedSelectedHotelFilters($event)"
        (remove)="innerRemoveByStaticHotel($event)">
      </app-selected-hotel-filters>
    </ng-container>
    <ng-container filterSlide="filterSlide">
      <app-hotel-filter-bar-slide
        [barFilters]="barFilters$ | async"
        [tagTypeIsPrime]="tagTypeIsPrime$ | async"
        [tagTypeIsRappicard]="tagTypeIsRappicard$ | async"
        [selectedStarItems]="selectedStarItems"
        [pickedMemberRatesOnly]="pickedMemberRatesOnly"
        [pickedStars]="pickedStars"
        [pickedTotalDiscountPercentage]="pickedTotalDiscountPercentage"
        [pickedCheckboxes]="pickedCheckboxes"
        [showExclusiveOfferFilter]="showExclusiveOfferFilter$ | async"
        (exclusiveOfferFilterEvent)="exclusiveOfferFilterAction()"
        (checkboxEvent)="checkboxAction($event)"
        (radioEvent)="radioAction($event)">
      </app-hotel-filter-bar-slide>
    </ng-container>
    <ng-container *ngIf="showPackHoursFilter" barWidgets="barWidgets">
      <app-byhours-filter-hour
      [isResults]="true"
      [hourType]="hourType"
      (hourTypeSelected)="applyHotelFilterVmBy($event)">
      </app-byhours-filter-hour>
    </ng-container>
    <ng-container moreBtn="moreBtn">
      <ng-content select="[moreFiltersTag]"></ng-content>
    </ng-container>
  </app-mobile-filter-bar-cont>
</ng-container>